module.exports = __webpack_public_path__ + "static/media/frames_Q7.0f3facf4.png";